import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import {
  HelperService,
  AppSettings,
  AuthenticationService,
  Agents,
} from '../../../services/_services';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import Swal from 'sweetalert2';

declare var document, $;

@Component({
  selector: 'app-available-leads',
  templateUrl: './available-leads.component.html',
  styleUrls: ['./available-leads.component.css'],
})
export class AvailableLeadsComponent implements OnInit {
  public despositionArray: any = AppSettings.disposition;
  public dispFirstEle: any;
  public documentTypeArray: any = AppSettings.documentType;
  public siteAbbr: any = AppSettings.siteAbbr;
  public orderStatus: any = AppSettings.orderStatus;

  public loading: any = false;
  public submitted: any = false;
  public paginatePage: any;
  public leads: any = [];
  public leads_Copy: any = [];
  public comments: any = [];
  public agentComments: any = [];
  public qaComments: any = [];
  public agentsSub: any;
  public agents: any;
  public qa: any;
  public loader: any;
  public qaloader: any;
  public activeUser: any;
  public notes: any = '';
  public lead_Index: any = null;
  public addCommentForm: FormGroup;
  public isMyTab: any = false;
  public limitExceeded: any = false;
  public leadStatusToUpdate: any = false;
  public floatingAlert: any = true;
  public salesIndex: any = null;
  public salesStatusVal: any = null;
  public siteList: any = AppSettings.siteList;
  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;
  public dtOptions: DataTables.Settings = {};
  public dtTrigger: any = new Subject();

  public searchParams: any = {
    emailId: '',
    disposition: null,
    status: null,
    agent_id: [],
    date_from: '',
    date_to: '',
    work_type: null,
  };
  public fullRangeDate: string[] = this.getDateRange();
  private getDateRange(): string[] {
    // Get current date/time in America/Los_Angeles
    const nowInLA = new Date(
      new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' })
    );
    console.log('Los Angeles current time:', nowInLA);
    // Set time to 00:00:00 for consistency (optional)
    nowInLA.setHours(0, 0, 0, 0);

    const formatDate = (date: Date): string => {
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const year = date.getFullYear();
      return `${month}-${day}-${year}`;
    };

    // Return the same date twice (start and end)
    return [formatDate(nowInLA), formatDate(nowInLA)];
  }
  public selectedDesposition: any;
  public actionUpdated: any;
  todayDateString: string;
  constructor(
    private helperService: HelperService,
    private agentsService: Agents,
    private authenticationService: AuthenticationService,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {
    // Get Agents
    this.agentsSub = this.agentsService.agentsS$.subscribe((agents) => {
      if (agents) {
        this.agents = agents.agents;
        this.qa = agents.qa;
      }
    });

    this.activeUser = this.authenticationService.get_currentUserValue();

    this.dtOptions = {
      paging: true,
      info: true,
      // ordering: false,
      pagingType: 'full_numbers',
      pageLength: 10,
      serverSide: true,
      processing: true,
      searching: false,
      language: AppSettings.dataTableLang,
      columnDefs: [
        { orderable: false, targets: 0 }, //lead id
        { orderable: true, targets: 1 }, //timestamp
        { orderable: false, targets: 2 }, //client info
        { orderable: false, targets: 3 }, //price
        { orderable: false, targets: 4 }, //acedmic
        { orderable: false, targets: 5 }, //document type
        { orderable: false, targets: 6 }, //due date
        { orderable: false, targets: 7 }, //disposition
        { orderable: false, visible: !this.isMyTab, targets: 8 }, //last agent
        { orderable: false, visible: !this.isMyTab, targets: 9 }, //action
        { orderable: false, visible: this.isMyTab, targets: 10 }, //followup
        { orderable: false, visible: this.isMyTab, targets: 11 }, //notes
        { orderable: false, targets: 12 }, //coments
      ],
      order: [[1, 'desc']],
      ajax: (dataTablesParameters: any, callback) => {
        // Show Loader
        this.loading = true;
        // console.log("dataTablesParameters", dataTablesParameters);

        let url;
        if (!this.isMyTab) {
          // For Sales Available Leads
          url = AppSettings.API_ENDPOINT + 'sales/available-leads';
        } else if (this.isMyTab) {
          // For My lead
          url = AppSettings.API_ENDPOINT + 'sales/my-leads';
        }

        let dtParams = {
          lead: this.searchParams.emailId,
          disposition:
            this.searchParams.disposition == null
              ? this.searchParams.disposition
              : this.searchParams.disposition.toString(),
          status: this.searchParams.status,
          agent_id: this.searchParams.agent_id,
          site_link: this.searchParams.site_link,
          date_from: this.searchParams.date_from
            ? this.helperService.caonvertDateToString(
                this.searchParams.date_from
              )
            : '',
          date_to: this.searchParams.date_to
            ? this.helperService.caonvertDateToString(
                this.searchParams.date_to,
                false
              )
            : '',
          work_type:
            this.searchParams.work_type &&
            this.searchParams.work_type.length > 0
              ? this.searchParams.work_type
              : null,
          start: dataTablesParameters.start,
          length: dataTablesParameters.length,
          order: dataTablesParameters.order,
          columns: dataTablesParameters.columns,
        };

        // For Record Serial Numbers
        this.paginatePage = dataTablesParameters.start;

        // Empty Data
        this.leads = [];

        this.helperService
          .httpPostRequestsDecryp(url, dtParams)
          .then((resp) => {
            this.leads = JSON.parse(resp);

            console.log('this.leads: ', this.leads);

            this.leads_Copy = $.extend(true, {}, this.leads);

            // Set Default page len
            this.dtOptions.pageLength = this.dtElement['dt'].page.len();

            // Hide Loader
            this.loading = false;

            callback({
              recordsTotal: this.leads.total,
              recordsFiltered: this.leads.total,
              // recordsFiltered: resp['recordsFiltered'],
              // recordsFiltered: 1000,
              data: [],
            });

            // // $(".paginate_button .current").css("color", "white");
            // // console.log('$(".paginate_button .current"): ',$(".paginate_button .current"))
            $('div.dataTables_length select').addClass('dt-form-control');
            $('div.dataTables_filter input').addClass('dt-form-control');
          })
          .catch((error) => {
            // Set loader false
            this.loading = false;

            // // Rerender DT in case of failure
            // this.rerender();

            console.log('error: ', error);
          });
      },
      columns: [
        // { data: 'multiDelete' },
        { data: 'id' },
        { data: 'date' },
        { data: 'name' },
        { data: 'price' },
        { data: 'level' },
        { data: 'work_type' },
        { data: 'due_date' },
        { data: 'status' },
        { data: 'agent' },
        { data: 'action' },
        { data: 'followup' },
        { data: 'notes' },
        { data: 'comments' },
      ],
      // Use this attribute to enable the responsive extension
      responsive: false,
    };
  }

  ngOnInit() {
    this.addCommentForm = this.formBuilder.group({
      comment: [null, Validators.required],
      commentDate: [''],
      commentTime: [''],
    });

    if (this.activeUser.Portal_Sales) {
      this.checkIfleadsAllowed();
    }
    console.log('despositionArray', this.despositionArray);
    const today = new Date(); // ✅ Declare it
    this.todayDateString = today.toISOString().split('T')[0]; // "YYYY-MM-DD"
  }

  ngAfterViewInit() {
    this.dtTrigger.next();
    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();

    if (typeof this.agentsSub != 'undefined') {
      //prevent memory leak when component destroyed
      this.agentsSub.unsubscribe();
    }
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();

      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  splitFromTo() {
    if (this.fullRangeDate) {
      this.searchParams.date_from = this.fullRangeDate[0];
      this.searchParams.date_to = this.fullRangeDate[1];
    }

    // console.log("this.fullRangeDate", this.fullRangeDate);
    // console.log("this.searchParams.date_from", this.searchParams.date_from);
    // console.log("this.searchParams.date_to", this.searchParams.date_to);

    this.rerender();
  }

  checkIfleadsAllowed() {
    let url = AppSettings.API_ENDPOINT + 'sales/check-if-leads-allowed';
    let data = { id: this.activeUser.user.id, status: 1 };
    this.helperService.httpPostRequests(url, data).then((resp) => {
      if (typeof resp != 'undefined') {
        // console.log('resp ---> ', resp);
        if (resp.data.limit_exceeded) {
          this.limitExceeded = true;
        }
      }
    });
  }

  openChangeDesposition(lead, index) {
    this.notes = '';
    this.salesIndex = index;
    this.salesStatusVal = this.leads.data[index].status;
    this.submitted = false;

    // Revert to actual until confirmed
    let self = this;
    setTimeout(() => {
      self.leads.data[index].status = self.leads_Copy.data[index].status;
    }, 50);

    // Show loader
    this.leads.data[index].loadingComms = true;

    // Get old Comments
    let url = AppSettings.API_ENDPOINT + 'shared/get-comments';
    let data = { l: lead.id, type: '' };

    this.helperService
      .httpPostRequests(url, data)
      .then((resp) => {
        if (typeof resp != 'undefined') {
          this.comments = resp.data;

          this.leads.data[index].oldComms = [];
          for (let i = 0; i < this.comments.length; i++) {
            if (this.comments[i].type == 'Leads-Comments') {
              this.leads.data[index].oldComms.push(this.comments[i]);
            }
          }
        }

        // Show Modal
        $('#commentsLeadsModal' + index).modal('show');
        $('.modal-backdrop').click(function () {
          $('#commentsLeadsModal' + index).modal('hide');
        });

        // Hide loader
        this.leads.data[index].loadingComms = false;
      })
      .catch((err) => {
        // Show Modal
        $('#commentsLeadsModal' + index).modal('show');
        $('.modal-backdrop').click(function () {
          $('#commentsLeadsModal' + index).modal('hide');
        });

        // Hide loader
        this.leads.data[index].loadingComms = false;
      });
  }

  updateCommentsAndDisposition(lead, index) {
    // Set Submission True
    this.submitted = true;

    // Stop here if form is invalid
    if (this.addCommentForm.invalid) {
      return;
    }

    if (this.salesStatusVal == 8) {
      const date = this.addCommentForm.value.commentDate;
      const time = this.addCommentForm.value.commentTime;
      const dateTimeString = `${date}T${time}:00`;
      const payload = {
        date_time: dateTimeString, // e.g., "2025-07-22T13:30:00"
      };
      if (dateTimeString !== 'nullTnull:00') {
        this.updateDesposition(lead, index, payload);
      }
    } else {
      this.updateDesposition(lead, index);
    }
    this.loading = true;

    this.submitted = false;
  }
  updateDesposition(lead, index, payload = null) {
    let url =
      AppSettings.API_ENDPOINT + 'shared/update-lead-comments-and-disposition';
    let data = {
      id: lead.id,
      status: this.salesStatusVal.toString(),
      comments: this.notes,
      follow_up_date: payload ? payload.date_time : null,
    };

    this.helperService
      .httpPostRequests(url, data)
      .then((resp) => {
        if (typeof resp != 'undefined') {
          this.notes = '';
          this.cdr.detectChanges();
          //$("#commentsLeadsModal"+index).modal("hide");
          Swal.fire('', resp.message, 'success');
        }
        this.loading = false;

        $('#commentsLeadsModal' + this.salesIndex).modal('hide');
        $('.modal-backdrop').remove();

        this.rerender();
      })
      .catch((err) => {
        Swal.fire('', 'Something went wrong. Please try again', 'error');

        // Hide Loader
        this.loading = false;
      });
  }
  showComments(lead, index, type = '') {
    // this.loader = true;
    this.agentComments = [];
    this.qaComments = [];

    if (type == 'QA-Leads-Comments') {
      this.qaloader = lead.id;
    } else {
      this.loader = lead.id;
    }

    let url = AppSettings.API_ENDPOINT + 'shared/get-comments';
    let data = { l: lead.id, type: '' };
    this.helperService.httpPostRequests(url, data).then((resp) => {
      if (typeof resp != 'undefined') {
        this.comments = resp.data;

        for (let i = 0; i < this.comments.length; i++) {
          if (this.comments[i].type == 'Leads-Comments') {
            this.agentComments.push(this.comments[i]);
          } else if (this.comments[i].type == 'QA-Leads-Comments') {
            this.qaComments.push(this.comments[i]);
          }
        }

        if (type == 'QA-Leads-Comments') {
          $('#notesModal' + index).modal('show');
        } else {
          if (
            type == '' &&
            this.agentComments.length == 0 &&
            this.qaComments.length == 0
          ) {
            Swal.fire(
              'No comments',
              "Agents and QA haven't added any comments yet.",
              'info'
            );
          } else if (
            type == 'Leads-Comments' &&
            this.agentComments.length == 0
          ) {
            Swal.fire(
              'No comments',
              "Agents haven't added any comments yet.",
              'info'
            );
          } else {
            if (typeof $ != 'undefined') {
              $('#comment_modal' + index).modal('show');
            }
          }
        }

        // Hide loaders
        this.loader = '';
        this.qaloader = '';

        $('.modal-backdrop').click(function () {
          $('#comment_modal' + index).modal('hide');
        });
      }
    });
  }

  openNotesModal(index) {
    this.submitted = false;
    this.notes = '';

    $('#notesModal' + index).modal('show');
  }

  get f() {
    return this.addCommentForm.controls;
  }

  updateSelfComments(lead, index) {
    // Set Submission True
    this.submitted = true;

    // Stop here if form is invalid
    if (this.addCommentForm.invalid) {
      return;
    }

    this.loading = true;

    let url =
      AppSettings.API_ENDPOINT + 'shared/update-self-comments-for-leads';
    let data = { id: lead.id, comments: this.notes };

    this.helperService
      .httpPostRequests(url, data)
      .then((resp) => {
        if (typeof resp != 'undefined') {
          this.leads.data[index].self_comments = this.notes;
          this.notes = '';
          this.cdr.detectChanges();

          $('#notesModal' + index).modal('hide');
          $('.modal-backdrop').remove();

          let self = this;
          this.leads.data[index].noteUpdated = true;
          setTimeout(() => {
            self.leads.data[index].noteUpdated = false;
          }, 1000);
        }

        this.loading = false;
      })
      .catch((err) => {
        Swal.fire('', 'Something went wrong. Please try again', 'error');

        // Hide Loader
        this.loading = false;
      });
  }

  agentSearch(id, agentArr) {
    for (var i = 0; i < agentArr.length; i++) {
      if (agentArr[i].id === id) {
        return agentArr[i].name;
      }
    }

    return '';
  }

  totalPaymentSearch(id, despoArr) {
    for (var i = 0; i < despoArr.length; i++) {
      if (despoArr[i].value === id) {
        return despoArr[i].name;
      }
    }

    return '';
  }

  showDisposition(id, statusArr) {
    for (var i = 0; i < statusArr.length; i++) {
      if (statusArr[i].value === id) {
        return statusArr[i].name;
      }
    }

    return '';
  }

  clearFilters() {
    this.fullRangeDate = null;
    this.searchParams = {
      emailId: '',
      disposition: null,
      agent_id: [],
      date_from: '',
      date_to: '',
      work_type: null,
    };

    this.rerender();
  }

  //update-lead-comments-and-disposition

  // sales portal starts
  openAssignToMe_Sales_Modal(index) {
    this.lead_Index = index;

    // Open Modal
    ($('#sales_assignme_modal' + index) as any).modal('show');
    $('.modal-backdrop').click(function () {
      $('#sales_assignme_modal' + index).modal('hide');
    });
  }

  assignToMe_Sales() {
    // Hide Modal
    ($('#sales_assignme_modal' + this.lead_Index) as any).modal('hide');
    $('.modal-backdrop').remove();

    // Show Status Loader
    this.leads.data[this.lead_Index].loading = true;

    let url = AppSettings.API_ENDPOINT + 'sales/assign-lead-to-me';
    let data = { id: this.leads.data[this.lead_Index].id, status: 1 };
    // console.log("data", data);
    this.helperService
      .httpPostRequests(url, data)
      .then((resp) => {
        // Hide Status Loader
        this.leads.data[this.lead_Index].loading = false;

        if (typeof resp != 'undefined' && resp.status == 'OK') {
          Swal.fire('', resp.message, 'success');
          // Remove lead as its assigned
          this.leads.data.splice(this.lead_Index, 1);
        }

        if (typeof resp != 'undefined' && resp.status == 'ERROR') {
          Swal.fire('', resp.message, 'error');
        }
      })
      .catch((err) => {
        // Hide Status Loader
        this.leads.data[this.lead_Index].loading = false;

        Swal.fire('', err.error.message, 'error');
      });
  }
  // sales portal ends

  // switch tab
  switchTab(flag) {
    if (this.isMyTab != flag) {
      this.isMyTab = flag;

      // Hide / Show Columns
      if (this.isMyTab) {
        // Remove the New Lead for My tab
        if (this.despositionArray[0].value == 0) {
          let arr = $.extend(true, [], this.despositionArray);
          this.dispFirstEle = arr.shift();
          this.despositionArray = arr;
        }

        // this.dtOptions.columnDefs[0].visible = false;
        this.dtOptions.columnDefs[8].visible = false;
        this.dtOptions.columnDefs[9].visible = false;
        this.dtOptions.columnDefs[10].visible = true;
        this.dtOptions.columnDefs[11].visible = true;
      } else {
        // Add the New Lead for Available Tab
        if (this.despositionArray[0].value != 0) {
          let arr = $.extend(true, [], this.despositionArray);
          arr.unshift(this.dispFirstEle);
          this.despositionArray = arr;
        }

        // this.dtOptions.columnDefs[0].visible = true;
        this.dtOptions.columnDefs[8].visible = true;
        this.dtOptions.columnDefs[9].visible = true;
        this.dtOptions.columnDefs[10].visible = false;
        this.dtOptions.columnDefs[11].visible = false;
      }

      this.rerender();
    }
  }

  closeFloatingAlert() {
    this.floatingAlert = false;
  }
  getAssignTimer(
    baseDate: string,
    assignDate: string
  ): { text: string; isGreen: boolean; tooltip: string } {
    if (!baseDate || !assignDate || assignDate.startsWith('0000')) {
      return { text: '', isGreen: true, tooltip: '' };
    }

    const base = new Date(baseDate);
    const assign = new Date(assignDate);

    const diffMs = assign.getTime() - base.getTime();
    const absDiffSec = Math.abs(diffMs) / 1000;

    const isGreen = absDiffSec <= 600; // 10 minutes = 600 seconds

    const days = Math.floor(absDiffSec / (3600 * 24));
    const hours = Math.floor((absDiffSec % (3600 * 24)) / 3600);
    const minutes = Math.floor((absDiffSec % 3600) / 60);
    const seconds = Math.floor(absDiffSec % 60);

    let timeStr = '';
    if (days) timeStr += `${days}d `;
    if (hours) timeStr += `${hours}h `;
    if (minutes) timeStr += `${minutes}m `;
    timeStr += `${seconds}s`;

    const tooltip = isGreen ? `within ${timeStr}` : `late by ${timeStr}`;

    return {
      text: diffMs >= 0 ? `Assign in ${timeStr}` : `Late by ${timeStr}`,
      isGreen,
      tooltip,
    };
  }
  isLateDisposed(assignDate: string, disposeDate: string): boolean {
    if (!assignDate || !disposeDate || disposeDate.startsWith('0000'))
      return false;

    const assign = new Date(assignDate);
    const dispose = new Date(disposeDate);

    const diffMs = dispose.getTime() - assign.getTime();
    const diffMinutes = diffMs / 1000 / 60;

    return diffMinutes > 10;
  }
  getRemainingTime(followUpDate: string): { text: string; isFuture: boolean } {
    if (!followUpDate || followUpDate.startsWith('0000')) {
      return { text: '', isFuture: true };
    }

    const target = new Date(followUpDate);
    const now = this.convertTZ(new Date(), 'America/Los_Angeles');
    const diff = target.getTime() - now.getTime();

    const isFuture = diff > 0;
    const absDiff = Math.abs(diff) / 1000; // in seconds

    const days = Math.floor(absDiff / (3600 * 24));
    const hours = Math.floor((absDiff % (3600 * 24)) / 3600);
    const minutes = Math.floor((absDiff % 3600) / 60);
    const seconds = Math.floor(absDiff % 60);

    let timeStr = '';
    if (days) timeStr += `${days}d `;
    if (hours || days) timeStr += `${hours}h `;
    if (minutes || hours || days) timeStr += `${minutes}m `;
    timeStr += `${seconds}s`;

    return {
      text: isFuture ? `${timeStr}` : `Late by ${timeStr}`,
      isFuture,
    };
  }
  convertTZ(date, tzString) {
    return new Date(
      (typeof date === 'string' ? new Date(date) : date).toLocaleString(
        'en-US',
        { timeZone: tzString }
      )
    );
  }
}
